import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const questionnairesFilterMixin = {
  data() {
    return {
      filteredQuestionnaires: [],
    };
  },
  watch: {
    questionnaires: {
      immediate: true,
      handler() {
        this.filteredQuestionnaires = this.questionnaires;
      },
    },
  },
  methods: {
    questionnairesFilterMethod(query) {
      this.filteredQuestionnaires = searchWithDiacritics(query, this.questionnaires, ['name']);
    },
    handleQuestionnairesVisibleChange() {
      setTimeout(() => {
        this.filteredQuestionnaires = this.questionnaires;
      }, 50);
    },
  },
};
